import { Modal, Ripple, initTWE } from "tw-elements";
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade, Thumbs } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui";
import LocomotiveScroll from "locomotive-scroll";
const locomotiveScroll = new LocomotiveScroll();
// Initialize Tailwind Elements components
initTWE({ Modal, Ripple });

// Configure Swiper 
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);

// Bind Fancybox
Fancybox.bind("[data-fancybox]", {});

document.addEventListener('DOMContentLoaded', function () {

    const domain = document.location.origin;

    // Function to initialize a carousel slider
    const initCarouselSwiper = (slider) => {
        const settings = {
            initialSlide: parseInt(slider.dataset.initialSlide) || 0, // Use dataset for data attributes
            loop: slider.dataset.loop === 'true',
            loopAdditionalSlides: 2,
            slidesPerView: slider.dataset.minSlides || 1,
            spaceBetween: 10,
            speed: 1000,
            autoplay: slider.dataset.autoplay ? { delay: parseInt(slider.dataset.autoplay) } : false,
            pagination: {
                el: slider.parentElement.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: slider.dataset.dynamicBullets || false,
                renderBullet: (index) => `<span class="swiper-pagination-bullet"><span>${index + 1}</span></span>`,
            },
            navigation: {
                nextEl: slider.parentElement.querySelector('.swiper-button-next'),
                prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                640: { slidesPerView: slider.dataset.minSlides || 1, spaceBetween: 20 },
                768: { slidesPerView: slider.dataset.maxSlides || 2 },
                1024: { slidesPerView: slider.dataset.maxSlides || 3 },
            },
        };

        return new Swiper(slider, settings);
    };

    // Initialize page banner Swiper
    const initPageBannerSwiper = () => {
        const homeBannerSwiper = document.querySelector('#main-hero .swiper');
        if (homeBannerSwiper) {
            new Swiper(homeBannerSwiper, {
                effect: homeBannerSwiper.dataset.effect || 'slide',
                loop: true,
                speed: 1000,
                autoplay: { delay: 5000 },
                pagination: {
                    el: homeBannerSwiper.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: homeBannerSwiper.querySelector('.swiper-button-next'),
                    prevEl: homeBannerSwiper.querySelector('.swiper-button-prev'),
                },
            });
        }
    };

    // Initialize all carousel sliders
    const initCarouselSliders = () => {
        document.querySelectorAll('.swiper-carousel .swiper').forEach(initCarouselSwiper);
    };

    initPageBannerSwiper();
    initCarouselSliders();

    // Product detail modal
    async function getProductData(id) {
        let domain = document.location.origin;
        try {
            const response = await fetch(`${domain}/wp-json/wp/v2/chimephu_product/${id}`);
            if (response.ok) {
                return await response.json();
            }
        } catch (error) {
            console.error('Error fetching reviews:', error);
            return null;
        }
    }

    const productItemsContainer = document.querySelector('.products');
    const productModal = document.getElementById('productModal');
    const modalContent = productModal?.querySelector('.modal-content');

    if (productItemsContainer && productModal && modalContent) {
        productItemsContainer.addEventListener('click', (e) => {
            const item = e.target.closest('.product-item');
            if (!item) return;

            e.preventDefault();
            const productId = item.dataset.product;
            if (!productId) return;

            item.classList.add('loading');
            const productModalInstance = new Modal(productModal);

            getProductData(productId).then(product => {
                if (product) {
                    const { regular_price: regularPrice, sale_price: salePrice } = product.acf;
                    const priceVNFormat = price => price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + 'đ';

                    let priceHTML = '';
                    if (regularPrice) {
                        priceHTML = salePrice
                            ? `<span class="sale-price text-brand-primary font-bold group-hover:text-white">${priceVNFormat(salePrice)}</span> <span class="regular-price line-through font-light">${priceVNFormat(regularPrice)}</span>`
                            : `<span class="regular-price font-bold text-brand-primary">${priceVNFormat(regularPrice)}</span>`;
                    }

                    modalContent.innerHTML = `
                        <div class="grid grid-cols-12 gap-4">
                            <div class="product-image col-span-4 bg-brand-primary rounded-xl overflow-hidden p-4">
                                <img class="aspect-square w-full h-full object-contain" src="${product.feature_image}" alt="${product.title.rendered}">
                            </div>
                            <div class="product-details col-span-8">
                                <h2 class="text-lg lg:text-xl font-bold mb-2">${product.title.rendered}</h2>
                                <div class="price text-lg lg:text-xl mb-4">${priceHTML}</div>
                                <div class="single-content text-sm">${product.content.rendered}</div>
                                <div class="apps flex gap-4 items-stretch mt-8">
                                    ${appLinks.grab ? `
                                    <a href="${appLinks.grab}" target="_blank" class="w-[120px] block overflow-hidden border rounded p-3 hover:border-gray-500">
                                        <img class="w-full h-full object-contain" src="/wp-content/themes/chimephu/assets/img/logo-grabfood.svg" alt="GrabFood" loading="lazy">
                                    </a>` : ''}
                                    ${appLinks.shopee ? `
                                    <a href="${appLinks.shopee}" target="_blank" class="w-[120px] block overflow-hidden border rounded p-3 hover:border-gray-500">
                                        <img class="w-full h-full object-contain" src="/wp-content/themes/chimephu/assets/img/logo-shopeefood.png" alt="ShopeeFood" loading="lazy">
                                    </a>` : ''}
                                    ${appLinks.be ? `
                                    <a href="${appLinks.be}" target="_blank" class="w-[120px] block overflow-hidden border rounded p-3 hover:border-gray-500">
                                        <img class="w-full h-full object-contain" src="/wp-content/themes/chimephu/assets/img/logo-befood.png" alt="BeFood" loading="lazy">
                                    </a>` : ''}
                                    ${appLinks.greensm ? `
                                    <a href="${appLinks.greensm}" target="_blank" class="w-[120px] block overflow-hidden border rounded p-3 hover:border-gray-500">
                                        <img class="w-full h-full object-contain" src="/wp-content/themes/chimephu/assets/img/logo-greensm.svg" alt="Greensm" loading="lazy">
                                    </a>` : ''}
                                </div>
                            </div>
                        </div>
                    `;
                    productModalInstance.show();
                    item.classList.remove('loading');
                }
            });
        });
    }
});
